import { Navigate } from "react-router-dom";

export default function KillSwitchDetailPage() {
  return <Navigate to="/forex/risk-config" replace />;
}
